import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { Divider } from '@mui/material';
import clsx from 'clsx';

import { useSidebarData } from '../../../hooks/useSidebarData';
import IsGranted from '../../../components/is-granted/IsGranted';
import Icon from '../../../icons/Icon';
import NavigationItem from './NavigationItem';

import scss from './MobileNavigation.module.scss';

function MobileNavigation({ onCloseMenu }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const sidebarData = useSidebarData();

  const handleNavigate = (path) => {
    navigate(path);
    onCloseMenu();
  };

  return (
    <nav>
      <ul className={scss.menuList}>
        {sidebarData.map(({ label, icon, url, isStrokeIcon, selectedRoutes, permissions, disabled, children }) => (
          <IsGranted key={label} permissions={permissions}>
            {children?.length ? (
              <MobileNavGroup
                label={label}
                icon={icon}
                isStrokeIcon={isStrokeIcon}
                selectedRoutes={selectedRoutes}
                pathname={pathname}
                items={children}
                onNavigate={handleNavigate}
              />
            ) : (
              <li>
                <NavigationItem
                  label={label}
                  icon={icon}
                  url={url}
                  pathname={pathname}
                  isStrokeIcon={isStrokeIcon}
                  selectedRoutes={selectedRoutes}
                  disabled={disabled}
                  onNavigate={handleNavigate}
                />
              </li>
            )}
          </IsGranted>
        ))}
      </ul>

      <Divider />
    </nav>
  );
}

function MobileNavGroup({ label, icon, isStrokeIcon, selectedRoutes = [], pathname, items, onNavigate }) {
  const childActive = items.some((child) => child.url === pathname);
  const isActive = childActive || selectedRoutes.includes(pathname);
  const [isExpanded, setIsExpanded] = useState(childActive);

  useEffect(() => {
    if (childActive) {
      setIsExpanded(true);
    }
  }, [childActive]);

  return (
    <li className={scss.group}>
      <button
        type='button'
        className={clsx(scss.navLink, scss.groupToggle, isActive && scss.navLinkActive)}
        onClick={() => setIsExpanded((prev) => !prev)}
        aria-expanded={isExpanded}>
        <span className={scss.iconWrapper}>
          <Icon
            icon={icon}
            size={18}
            className={clsx(scss.icon, isStrokeIcon && scss.iconStroke)}
            disableCommonColors
          />
        </span>
        <span className={scss.label}>{label}</span>
        <span className={clsx(scss.caret, isExpanded && scss.caretOpen)} />
      </button>

      {isExpanded ? (
        <ul className={scss.submenu}>
          {items.map((child) => (
            <IsGranted key={child.url} permissions={child.permissions}>
              <li>
                <NavigationItem
                  label={child.label}
                  icon={child.icon}
                  url={child.url}
                  pathname={pathname}
                  isStrokeIcon={child.isStrokeIcon}
                  disabled={child.disabled}
                  onNavigate={onNavigate}
                  isChild
                />
              </li>
            </IsGranted>
          ))}
        </ul>
      ) : null}
    </li>
  );
}

export default MobileNavigation;
